import { IAttendanceSessionDefinition } from "../../../models/AttendanceConfiguration";

export const legacyAttendanceSessionDefinitions: readonly IAttendanceSessionDefinition[] = [
    { id: "am", label: "AM registration", shortLabel: "AM", kind: "registration" },
    { id: "pm", label: "PM registration", shortLabel: "PM", kind: "registration" },
];

export const defaultAttendanceSessionDefinitions: readonly IAttendanceSessionDefinition[] = [
    { id: "am", label: "AM registration", shortLabel: "AM", kind: "registration" },
    { id: "pm", label: "PM registration", shortLabel: "PM", kind: "registration" },
];